import { render, staticRenderFns } from "./MapTrip.vue?vue&type=template&id=2840c4b4&scoped=true&"
import script from "./MapTrip.vue?vue&type=script&lang=js&"
export * from "./MapTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840c4b4",
  null
  
)

export default component.exports